import { render, staticRenderFns } from "./ReportECG.vue?vue&type=template&id=502128ca&"
import script from "./ReportECG.vue?vue&type=script&lang=js&"
export * from "./ReportECG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports